import { render, staticRenderFns } from "./HomePageSectionHeader.vue?vue&type=template&id=ba145c1a&"
import script from "./HomePageSectionHeader.vue?vue&type=script&lang=js&"
export * from "./HomePageSectionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports